import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LanguageContext from 'resources/stringLocale';
import logo from './images/nweaTagline.svg';


const propTypes = {
    thrownError: PropTypes.shape().isRequired,
};

function ErrorPage({ thrownError }) {
    let errType = 1800;

    if (thrownError.code) {
        errType = thrownError.code;
    }

    const errorStrings = useContext(LanguageContext).errors;
    const { header, description, helpList } =
        errType !== 1800
            ? errorStrings[errType]
            : { ...errorStrings[errType], ...{ description: thrownError.message } };

    /* eslint "react/no-array-index-key": "off" */
    // Couldn't figure out a clean way to uniquely ID these indexes.
    // As long as this list is never reorganized and new elements are not added anywhere in the list after render, it should be safe.
    const helpListItems = helpList.map((element, index) => {
        return (
            <li key={index} className={'help-item'}>
                {element}
            </li>
        );
    });

    return (
        <main className={'error-box'}>
            <figure className={'header'}>
                <svg className={'logo-svg'} viewBox={logo.viewBox} height="50">
                    <use href={`#${logo.id}`} />
                </svg>
            </figure>
            <section className={'error-content'}>
                <h1 data-testid="error-page-header" className={'error-header'}>
                    {header}
                </h1>
                <p data-testid="error-page-description" className={'error-description'}>
                    {description}
                </p>
                <p>{errorStrings.common.pleaseTry}</p>
                <ol className={'error-help-list'}>{helpListItems}</ol>
                <br />
            </section>
        </main>
    );
}

ErrorPage.propTypes = propTypes;

export default ErrorPage;
